import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/plot', label: '剧情介绍' },
  { to: '/characters', label: '角色设定' },
  { to: '/episodes', label: '分集剧情' },
  { to: '/faq', label: '常见问题' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled && !open;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        transparent
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur border-b border-background-200'
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 cursor-pointer" aria-label="泡在我家的辣妹资料站 首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full ${
              transparent ? 'bg-background-50/20 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-emotion-happy-line text-lg" />
          </span>
          <span
            className={`font-heading text-lg md:text-xl ${
              transparent ? 'text-background-50' : 'text-foreground-950'
            }`}
          >
            泡在我家的辣妹
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : transparent
                      ? 'text-background-50/90 hover:bg-background-50/20'
                      : 'text-foreground-800 hover:bg-primary-100'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-full md:hidden cursor-pointer ${
            transparent ? 'text-background-50' : 'text-foreground-900'
          }`}
          aria-label="打开或关闭菜单"
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `rounded-lg px-4 py-2.5 text-sm font-medium cursor-pointer ${
                    isActive ? 'bg-primary-500 text-background-50' : 'text-foreground-800 hover:bg-primary-100'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}